var render = function render(){var _vm=this,_c=_vm._self._c;return _c('login-layout',{attrs:{"title":_vm.pwdTit}},[_c('div',{staticClass:"login-suc-box"},[_c('i',{staticClass:"icon iconfont iconicon-test33 suc-ico"}),_c('p',[_vm._v(_vm._s(_vm.$t('message["1569"]')))]),_c('p',[_vm._v(_vm._s(_vm.duration)+_vm._s(_vm.$t('message["642"]'))+"…")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }